module.exports = __webpack_public_path__ + "media/newstyle/images/icon-profile-eefe149cb41f74cda91ffa5149732168.svg";